var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-tabs"},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:("tab-" + (tab.label)),staticClass:"tab",attrs:{"to":tab.route}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }